import {Injectable, NgZone, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';

/**
 * Detects hardware barcode scanner input. Scanners emit rapid keypresses
 * ending in Enter. We buffer characters arriving < 200ms apart and emit
 * the completed string when Enter fires (if it looks like a badge scan).
 */
@Injectable({providedIn: 'root'})
export class BarcodeScanService implements OnDestroy {
  readonly scanned$ = new Subject<string>();

  private buffer = '';
  private lastKeyTime = 0;
  private readonly MAX_GAP_MS = 200;
  private listener: (e: KeyboardEvent) => void;

  constructor(private zone: NgZone) {
    this.listener = (e: KeyboardEvent) => this.onKeydown(e);
    // Run outside Angular to avoid change detection on every keystroke
    this.zone.runOutsideAngular(() => {
      document.addEventListener('keydown', this.listener, true);
    });
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.listener, true);
  }

  private onKeydown(e: KeyboardEvent): void {
    const now = Date.now();

    if (e.key === 'Enter' && this.buffer.length >= 5) {
      const code = this.buffer;
      this.buffer = '';
      this.lastKeyTime = 0;
      if (/^EMP:[\w-]+$/i.test(code)) {
        e.preventDefault();
        e.stopPropagation();
        this.zone.run(() => this.scanned$.next(code));
      }
      return;
    }

    if (e.key.length === 1) {
      if (now - this.lastKeyTime > this.MAX_GAP_MS) {
        this.buffer = '';
      }
      this.buffer += e.key;
      this.lastKeyTime = now;
    }
  }
}
